/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_ASSETS(state, data) {
    state.assets = data;
    if (data.length > 0) {
      state.currentAssetIdInDB = data[0].idInDB;
    }
  },
  ADD_NEW_CREATED_ASSET(state, data) {
    state.assets.unshift(data);
  },
  SET_CURRENT_ASSET_ID(state, id) {
    state.currentAssetIdInDB = id;
  },
  UPDATE_ASSET(state, data) {
    const index = state.assets.findIndex(element => element.idInDB === data.idInDB);
    if (index == -1) {
      state.assets.push(data);
    } else {
      state.assets[index] = data;
    }
  }
};
